import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11eb3080"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24 -md:pt-16 p-5" }
const _hoisted_2 = { class: "px-6 py-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Licenças", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_6 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_7 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_8 = {
  id: "example",
  class: "stripe hover",
  style: {"width":"100%","padding-top":"1em","padding-bottom":"1em"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "1"
    }, "Linha"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "Produto"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "Ativas"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "Inativas"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "3"
    }, "Bloqueadas"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "3"
    }, " ")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "NFSE", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Modulo SaaS NFSe Ilimitado", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "1", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "1", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "0", -1))
const _hoisted_16 = { class: "flex gap-5" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://managersaas.tecnospeed.com.br/#/admin",
  class: "ml-auto border-blue-500 border rounded-lg text-blue-500 p-2 cursor-pointer hover:bg-blue-500 hover:text-white transition"
}, " Painel Saas ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "CTE", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Modulo SaaS CTe Ilimitado", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "1", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "1", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "0", -1))
const _hoisted_23 = { class: "flex gap-5" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  rel: "noopener noreferrer",
  target: "_blank",
  href: "https://managersaas.tecnospeed.com.br/#/admin",
  class: "ml-auto border-blue-500 border rounded-lg text-blue-500 p-2 cursor-pointer hover:bg-blue-500 hover:text-white transition"
}, " Painel Saas ", -1))
const _hoisted_25 = { class: "py-8 pt-3" }
const _hoisted_26 = { class: "block md:flex gap-5" }
const _hoisted_27 = { class: "block" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Descrição ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_31 = { class: "gap-5 flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.registering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_11,
                        _hoisted_12,
                        _hoisted_13,
                        _hoisted_14,
                        _hoisted_15,
                        _createElementVNode("td", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.disable(_ctx.usuario))),
                            class: "border-green-500 border rounded-lg text-green-500 p-2 cursor-pointer hover:bg-green-500 hover:text-white transition"
                          }, " Relatório ")
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_18,
                        _hoisted_19,
                        _hoisted_20,
                        _hoisted_21,
                        _hoisted_22,
                        _createElementVNode("td", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("div", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.disable(_ctx.usuario))),
                            class: "border-green-500 border rounded-lg text-green-500 p-2 cursor-pointer hover:bg-green-500 hover:text-white transition"
                          }, " Relatório ")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.registering)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 1,
            class: "pt-8 px-6 m-5 mx-auto",
            width: "max-w-min",
            title: "Cadastrar nova mensagem",
            orientation: "flex-col"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_Select, {
                    selected: "Produto",
                    label: "Produto",
                    options: () => _ctx.selectValues,
                    display: "descricao",
                    itemId: "value",
                    labelClass: "p-0 text-left",
                    event: "update:editValue",
                    class: "w-6/6 md:w-3/6",
                    "onUpdate:editValue": _ctx.changeType,
                    incorrectMessage: _ctx.validations.package,
                    isIncorrect: _ctx.validations.package != ''
                  }, null, 8, ["options", "onUpdate:editValue", "incorrectMessage", "isIncorrect"]),
                  _createVNode(_component_Input, {
                    label: "Título",
                    class: "w-6/6 md:w-3/6",
                    incorrectMessage: _ctx.validations.titulo,
                    isIncorrect: _ctx.validations.titulo != '',
                    labelClass: "p-0 text-left",
                    modelValue: _ctx.mensagem.titulo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mensagem.titulo) = $event))
                  }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _hoisted_29,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "border outline-none border-gray-300 rounded-lg w-full p-3 mb-3 custom-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mensagem.descricao) = $event)),
                    rows: "5"
                  }, null, 512), [
                    [_vModelText, _ctx.mensagem.descricao]
                  ])
                ]),
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.mensagem.dates,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mensagem.dates) = $event)),
                  "is-range": "",
                  columns: _ctx.width() > 768 ? 2 : 1,
                  class: _normalizeClass(["my-1", _ctx.validations.dates != '' ? 'border-red-500' : ''])
                }, null, 8, ["modelValue", "columns", "class"]),
                (_ctx.validations.dates != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Informe as datas de visibilidade da mensagem! "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_Button, {
                    label: "Voltar",
                    onClick: _ctx.back,
                    class: "p-0 my-4 w-full divide-transparent",
                    width: "w-min"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_PrimaryButton, {
                    isLoading: _ctx.loading,
                    label: "Enviar",
                    onClick: _ctx.send,
                    class: "p-0 my-4 w-full divide-transparent text-white",
                    width: "w-full",
                    type: "submit"
                  }, null, 8, ["isLoading", "onClick"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Toast, {
        label: _ctx.message,
        hidden: _ctx.hidden,
        onHide: _ctx.hide
      }, null, 8, ["label", "hidden", "onHide"])
    ])
  ]))
}